import { useContext } from 'react';
import { PropertyContext } from '../context/PropertyContext';
export const usePropertyAccessLevelOverride = () => useContext(PropertyContext).accessLevelOverride;